import React from 'react';

import type { CardMediaProps } from './Card.types';
import clsx from 'clsx';

export const CardMedia = React.forwardRef<HTMLImageElement, CardMediaProps>(
  (
    {
      as: Component = 'img',
      children,
      className,
      testId,
      theme,
      variant = 'top',
      ...restProps
    },
    ref
  ) => {
    return (
      <div
        className={clsx({
          'hg-card__media': variant === 'none',
          [`hg-card__media--${variant}`]: variant && variant !== 'none',
        })}
        data-theme={theme}
      >
        <Component
          {...restProps}
          ref={ref}
          data-testid={testId}
          className={className}
        />
        {children}
      </div>
    );
  }
);

CardMedia.displayName = 'Card.Media';
